import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { getFeeDistributorContract } from '~/contracts/getFeeDistributorContract'
import { getVotingEscrowContract } from '~/contracts/getVotingEscrowContract'
import { useVESISParams } from '~/hooks/useVESISParams'
import { getWeeklySISDistribution } from '~/lib/getEstimateWeaklyRewards'
import { getGraphUserInfo } from '~/lib/getGraphUserInfo'
import { sisLockKeys } from '~/lib/queryKeys'
import { useWallet } from '~/lib/useWallet'

type QueryData<T> = T extends UseQueryResult<infer R> ? R : never

export type Locked = QueryData<ReturnType<typeof useLockChangeDetails>>

export function useLockChangeDetails() {
	const { config, provider } = useVESISParams()
	const { account } = useWallet()

	return useQuery({
		queryKey: sisLockKeys.changeDetails(config.chain.id, account),
		queryFn: async () => {
			const feeDistributorContract = getFeeDistributorContract(
				config,
				provider
			)
			const votingEscrowContract = getVotingEscrowContract(
				config,
				provider
			)

			const { amount, end } = await votingEscrowContract.locked(account)
			const veSISBalance = await votingEscrowContract[
				'balanceOf(address)'
			](account)

			const distribution = getWeeklySISDistribution(
				config,
				provider,
				feeDistributorContract
			)

			const [tokensPerWeek, totalVESISSupply] = await Promise.all([
				distribution,
				votingEscrowContract['totalSupply()'](),
			])

			const user = await getGraphUserInfo(config, account)

			if (!user) {
				throw new Error('Create lock Deposit event not found')
			}

			return {
				amount,
				end,
				start: user.lastLockTime,
				tokensPerWeek,
				totalVESISSupply,
				veSISBalance,
			}
		},
		enabled: !!account,
	})
}
